import {
  SIGNIN_USER_SUCCESS,
  SIGNIN_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNOUT_USER,
  IMPERSONATE_USER,
  IMPERSONATE_USER_SUCCESS,
  LEAVE_IMPERSONATION,
  LEAVE_IMPERSONATION_SUCCESS,
} from '../constants/ActionsTypes'

export const userSignIn = (credentials) => {
  return {
    type: SIGNIN_USER,
    payload: credentials,
  }
}

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser,
  }
}

export const userSignOut = () => {
  return {
    type: SIGNOUT_USER,
  }
}

export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
}

export const impersonateUser = (userId) => {
  return {
    type: IMPERSONATE_USER,
    payload: { userId },
  }
}

export const impersonateUserSuccess = (authUser) => {
  return {
    type: IMPERSONATE_USER_SUCCESS,
    payload: authUser,
  }
}

export const leaveImpersonation = () => {
  return {
    type: LEAVE_IMPERSONATION,
  }
}

export const leaveImpersonationSuccess = (authUser) => {
  return {
    type: LEAVE_IMPERSONATION_SUCCESS,
    payload: authUser,
  }
}
